import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { formatError } from '../lib/api';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      if (u.role === 'admin') navigate('/admin');
      else if (u.role === 'tradie') navigate('/tradie');
      else navigate('/search');
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6]" data-testid="login-page">
      <div className="mx-auto max-w-md px-6 py-16">
        <Link to="/" className="text-sm text-[#8A8988] hover:text-[#1A362D]">← Back</Link>
        <h1 className="mt-6 font-heading text-4xl font-bold tracking-tight text-[#1C1B1A]">Welcome back</h1>
        <p className="mt-2 text-[#5C5B5A]">Sign in to your Trades &amp; Neighbours account.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email" data-testid="login-email" className="input-editorial" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password" data-testid="login-password" className="input-editorial" />
          <button type="submit" disabled={busy} data-testid="login-submit" className="btn-primary w-full justify-center disabled:opacity-50">
            {busy ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <p className="mt-6 text-sm text-[#5C5B5A]">
          New here? <Link to="/register" className="font-semibold text-[#1A362D] underline">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
